"use strict";
import { getCapabilities as wagmi_getCapabilities } from "@wagmi/core/experimental";
import { wagmiConfig } from "components/Web3Provider/wagmiConfig";
import { ensureValidatedCapabilities } from "state/walletCapabilities/lib/ensureValidatedCapabilities";
import { ensure0xHex, numberToHex } from "uniswap/src/utils/hex";
import { getLogger } from "utilities/src/logger/logger";
const TIMEOUT_MS = 5e3;
export async function handleGetCapabilities(input) {
  let timeoutId;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(() => reject(new Error("getCapabilities timeout")), TIMEOUT_MS);
  });
  try {
    const capabilities = await Promise.race([walletGetCapabilities(input), timeoutPromise]);
    const validatedCapabilities = ensureValidatedCapabilities(capabilities);
    if (validatedCapabilities) {
      return validatedCapabilities;
    } else {
      throw new Error(`Invalid capabilities format: ${JSON.stringify(capabilities)}`);
    }
  } catch (error) {
    if (error instanceof Error && error.message.includes("getCapabilities timeout")) {
      return null;
    }
    getLogger().warn("useWalletCapabilities", "handleGetCapabilities", `Error getting capabilities: ${error}`);
    return null;
  } finally {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }
}
async function walletGetCapabilities(input) {
  if (!input?.address && !input?.connector) {
    return wagmi_getCapabilities(wagmiConfig);
  }
  return wagmi_getCapabilities(wagmiConfig, {
    account: input.address,
    connector: input.connector
  });
}
var AtomicBatchingStatus = /* @__PURE__ */ ((AtomicBatchingStatus2) => {
  AtomicBatchingStatus2["Supported"] = "supported";
  AtomicBatchingStatus2["Ready"] = "ready";
  AtomicBatchingStatus2["Unsupported"] = "unsupported";
  return AtomicBatchingStatus2;
})(AtomicBatchingStatus || {});
export function isAtomicBatchingSupported(chainCapabilities) {
  return chainCapabilities?.atomic?.status === "supported" /* Supported */ || chainCapabilities?.atomic?.status === "ready" /* Ready */ || // TODO(WEB-7872): Remove temporary support for v1 of atomic batching schema for coinbase wallet (remove line below)
  chainCapabilities?.atomicBatch?.supported === true;
}
export function isAtomicBatchingSupportedByChainId(chainCapabilitiesResult, chainId) {
  const key = ensure0xHex(numberToHex(chainId));
  const chainCapabilities = chainCapabilitiesResult[key];
  if (!chainCapabilities) {
    return false;
  }
  return isAtomicBatchingSupported(chainCapabilities);
}
export function getAtomicSupportedChainIds(chainCapabilitiesResult) {
  if (!chainCapabilitiesResult) {
    return [];
  }
  return Object.entries(chainCapabilitiesResult).filter(([_, capabilities]) => isAtomicBatchingSupported(capabilities)).map(([chainIdHex]) => parseInt(chainIdHex, 16));
}
